export default {"src":"/_next/static/media/logo-alfa.f30050c5.svg","height":1959,"width":5017,"blurWidth":0,"blurHeight":0};